export default __webpack_public_path__ + "static/media/Siyaram Silk Mills Limited.6ed10a68.jpg";